/**
 * deleteTable.ts - Delete the whole table via the embedding surface's delete handler.
 */

import {assert} from 'Asserts';
import type {TableMutationParams} from 'notebook/tables/store/logic/mutations/mutationParams';

/**
 * Delete the whole table via the embedding surface's delete handler.
 *
 * Only valid when {@link TableModel.canDeleteTable} is true; callers gate on it.
 */
export function deleteTable(params: TableMutationParams): void {
  const {deleteHandler} = params.getTableModel().props;
  assert(deleteHandler != null, 'Expected a delete handler when deleting the table');
  deleteHandler();
}
